import { ClearPayMessageUI } from "./ClearPayMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
export function ClearPayMessage({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) {
  const {
    variant: {
      aliases: { skuId },
      price,
    },
    isSelected,
  } = useVariant(product);

  const excludeSellingProductType =
    !!product.sellingProductType?.includes("Alcohol");

  return (
    <ClearPayMessageUI
      runtimeConfig={runtimeConfig}
      skuId={skuId}
      currentPrice={price?.value}
      isSelected={isSelected}
      shouldExcludeProduct={excludeSellingProductType}
    />
  );
}
